export const residentUsers = [
  {
    id: "R001",
    name: "张建国",
    idCard: "110101198503152341",
    phone: "13812345678",
    address: "北京市朝阳区建国路88号3单元502室",
    accountDate: "2018-03-15",
    safetyLevel: 92,
    safetyGrade: "A",
    lastInspection: "2025-11-20",
    nextInspection: "2026-05-20",
    monthlyUsage: 28.5,
    yearlyUsage: 342.0,
    balance: 256.80,
    status: "正常",
    insurance: { valid: true, expiry: "2026-12-31", company: "中国人寿" },
    devices: [
      {
        id: "D001",
        type: "燃气表",
        model: "G4-IC卡智能燃气表",
        spec: "G4",
        manufacturer: "金卡智能",
        productionDate: "2021-06-15",
        installDate: "2021-07-01",
        calibrationDate: "2024-07-01",
        nextCalibration: "2026-07-01",
        status: "正常",
        iotId: "IOT-R001-GM",
        currentReading: 1842.36,
      },
      {
        id: "D002",
        type: "报警器",
        model: "JT-B2燃气泄漏报警器",
        spec: "220V/DC9V",
        manufacturer: "海湾安全",
        productionDate: "2022-03-10",
        installDate: "2022-04-01",
        calibrationDate: "2025-04-01",
        nextCalibration: "2027-04-01",
        status: "正常",
        iotId: "IOT-R001-AL",
        currentReading: null,
      },
    ],
    portrait: {
      cookingFrequency: "每天3次",
      familySize: 4,
      peakHours: "07:00-08:30, 18:00-20:00",
      cuisine: "川菜、家常菜",
      habits: ["早餐用气", "晚餐用气量大", "周末用气明显增加"],
      appliances: ["双眼灶", "热水器", "壁挂炉"],
      insurance: true,
      safetyCheck: "按时",
    },
    usageHistory: [
      { month: "2025-01", usage: 32.1, cost: 96.3 },
      { month: "2025-02", usage: 28.5, cost: 85.5 },
      { month: "2025-03", usage: 25.2, cost: 75.6 },
      { month: "2025-04", usage: 22.8, cost: 68.4 },
      { month: "2025-05", usage: 20.1, cost: 60.3 },
      { month: "2025-06", usage: 18.6, cost: 55.8 },
      { month: "2025-07", usage: 17.2, cost: 51.6 },
      { month: "2025-08", usage: 16.8, cost: 50.4 },
      { month: "2025-09", usage: 19.5, cost: 58.5 },
      { month: "2025-10", usage: 24.3, cost: 72.9 },
      { month: "2025-11", usage: 29.8, cost: 89.4 },
      { month: "2025-12", usage: 31.6, cost: 94.8 },
    ],
  },
  {
    id: "R002",
    name: "李秀梅",
    idCard: "110102196812203456",
    phone: "13698765432",
    address: "北京市海淀区中关村南大街15号1单元301室",
    accountDate: "2015-08-22",
    safetyLevel: 78,
    safetyGrade: "B",
    lastInspection: "2025-08-15",
    nextInspection: "2026-02-15",
    monthlyUsage: 35.2,
    yearlyUsage: 422.4,
    balance: 89.50,
    status: "欠费预警",
    insurance: { valid: false, expiry: "2025-06-30", company: "平安保险" },
    devices: [
      {
        id: "D003",
        type: "燃气表",
        model: "G6-NB-IoT智能燃气表",
        spec: "G6",
        manufacturer: "新天科技",
        productionDate: "2019-09-20",
        installDate: "2019-10-15",
        calibrationDate: "2023-10-15",
        nextCalibration: "2025-10-15",
        status: "待校验",
        iotId: "IOT-R002-GM",
        currentReading: 3256.78,
      },
    ],
    portrait: {
      cookingFrequency: "每天2次",
      familySize: 2,
      peakHours: "07:00-08:00, 17:30-19:00",
      cuisine: "粤菜、清淡",
      habits: ["早餐简单", "晚餐为主", "冬季用气量大"],
      appliances: ["单眼灶", "热水器"],
      insurance: false,
      safetyCheck: "逾期",
    },
    usageHistory: [
      { month: "2025-01", usage: 38.5, cost: 115.5 },
      { month: "2025-02", usage: 35.2, cost: 105.6 },
      { month: "2025-03", usage: 30.1, cost: 90.3 },
      { month: "2025-04", usage: 28.6, cost: 85.8 },
      { month: "2025-05", usage: 25.3, cost: 75.9 },
      { month: "2025-06", usage: 22.1, cost: 66.3 },
      { month: "2025-07", usage: 20.5, cost: 61.5 },
      { month: "2025-08", usage: 21.8, cost: 65.4 },
      { month: "2025-09", usage: 26.4, cost: 79.2 },
      { month: "2025-10", usage: 31.2, cost: 93.6 },
      { month: "2025-11", usage: 36.8, cost: 110.4 },
      { month: "2025-12", usage: 40.1, cost: 120.3 },
    ],
  },
  {
    id: "R003",
    name: "王大明",
    idCard: "110103197506184567",
    phone: "15912345678",
    address: "北京市西城区长安街100号5单元1201室",
    accountDate: "2020-01-10",
    safetyLevel: 95,
    safetyGrade: "A+",
    lastInspection: "2026-01-05",
    nextInspection: "2026-07-05",
    monthlyUsage: 42.8,
    yearlyUsage: 513.6,
    balance: 520.00,
    status: "正常",
    insurance: { valid: true, expiry: "2027-01-31", company: "太平洋保险" },
    devices: [
      {
        id: "D005",
        type: "燃气表",
        model: "G10-NB-IoT智能燃气表",
        spec: "G10",
        manufacturer: "金卡智能",
        productionDate: "2020-01-05",
        installDate: "2020-01-10",
        calibrationDate: "2024-01-10",
        nextCalibration: "2026-01-10",
        status: "正常",
        iotId: "IOT-R003-GM",
        currentReading: 2156.42,
      },
      {
        id: "D006",
        type: "报警器",
        model: "JT-B3燃气泄漏报警器",
        spec: "220V/DC9V",
        manufacturer: "海湾安全",
        productionDate: "2020-01-05",
        installDate: "2020-01-10",
        calibrationDate: "2025-01-10",
        nextCalibration: "2027-01-10",
        status: "正常",
        iotId: "IOT-R003-AL",
        currentReading: null,
      },
    ],
    portrait: {
      cookingFrequency: "每天4次",
      familySize: 6,
      peakHours: "06:30-08:00, 11:30-13:00, 17:00-19:30",
      cuisine: "北方菜、面食",
      habits: ["三餐用气", "周末聚餐用气量大", "冬季壁挂炉用气"],
      appliances: ["三眼灶", "热水器", "壁挂炉", "烤箱"],
      insurance: true,
      safetyCheck: "按时",
    },
    usageHistory: [
      { month: "2025-01", usage: 55.2, cost: 165.6 },
      { month: "2025-02", usage: 48.6, cost: 145.8 },
      { month: "2025-03", usage: 42.1, cost: 126.3 },
      { month: "2025-04", usage: 38.5, cost: 115.5 },
      { month: "2025-05", usage: 35.2, cost: 105.6 },
      { month: "2025-06", usage: 30.8, cost: 92.4 },
      { month: "2025-07", usage: 28.6, cost: 85.8 },
      { month: "2025-08", usage: 29.1, cost: 87.3 },
      { month: "2025-09", usage: 35.6, cost: 106.8 },
      { month: "2025-10", usage: 42.3, cost: 126.9 },
      { month: "2025-11", usage: 50.1, cost: 150.3 },
      { month: "2025-12", usage: 56.8, cost: 170.4 },
    ],
  },
  {
    id: "R004",
    name: "陈小红",
    idCard: "110104199201087890",
    phone: "18612345678",
    address: "北京市丰台区南三环西路68号2单元801室",
    accountDate: "2022-06-18",
    safetyLevel: 85,
    safetyGrade: "A",
    lastInspection: "2025-12-10",
    nextInspection: "2026-06-10",
    monthlyUsage: 18.3,
    yearlyUsage: 219.6,
    balance: 180.20,
    status: "正常",
    insurance: { valid: true, expiry: "2026-06-30", company: "中国人保" },
    devices: [
      {
        id: "D007",
        type: "燃气表",
        model: "G2.5-IC卡智能燃气表",
        spec: "G2.5",
        manufacturer: "新天科技",
        productionDate: "2022-06-01",
        installDate: "2022-06-18",
        calibrationDate: "2025-06-18",
        nextCalibration: "2027-06-18",
        status: "正常",
        iotId: "IOT-R004-GM",
        currentReading: 456.82,
      },
    ],
    portrait: {
      cookingFrequency: "每天1-2次",
      familySize: 2,
      peakHours: "07:30-08:30, 18:30-20:00",
      cuisine: "简餐、外卖为主",
      habits: ["早餐偶尔用气", "晚餐为主", "用气量较少"],
      appliances: ["双眼灶", "热水器"],
      insurance: true,
      safetyCheck: "按时",
    },
    usageHistory: [
      { month: "2025-01", usage: 22.1, cost: 66.3 },
      { month: "2025-02", usage: 20.5, cost: 61.5 },
      { month: "2025-03", usage: 18.2, cost: 54.6 },
      { month: "2025-04", usage: 16.8, cost: 50.4 },
      { month: "2025-05", usage: 15.3, cost: 45.9 },
      { month: "2025-06", usage: 14.1, cost: 42.3 },
      { month: "2025-07", usage: 13.5, cost: 40.5 },
      { month: "2025-08", usage: 13.8, cost: 41.4 },
      { month: "2025-09", usage: 16.2, cost: 48.6 },
      { month: "2025-10", usage: 18.9, cost: 56.7 },
      { month: "2025-11", usage: 21.3, cost: 63.9 },
      { month: "2025-12", usage: 23.6, cost: 70.8 },
    ],
  },
];

export const commercialUsers = [
  {
    id: "C001",
    name: "老北京涮肉馆",
    type: "小餐饮业",
    license: "91110101MA0001AB1X",
    contact: "刘老板",
    phone: "13512345678",
    address: "北京市东城区鼓楼东大街56号",
    accountDate: "2019-05-20",
    safetyLevel: 88,
    safetyGrade: "A",
    lastInspection: "2025-10-15",
    nextInspection: "2026-04-15",
    monthlyUsage: 1256.8,
    yearlyUsage: 15081.6,
    balance: 3580.00,
    status: "正常",
    insurance: { valid: true, expiry: "2026-08-31", company: "中国人寿" },
    devices: [
      {
        id: "DC001",
        type: "流量计",
        model: "LWQ-50涡轮流量计",
        spec: "DN50, 0-100m³/h",
        manufacturer: "北京天信仪表",
        productionDate: "2019-04-10",
        installDate: "2019-05-20",
        calibrationDate: "2024-05-20",
        nextCalibration: "2026-05-20",
        status: "正常",
        iotId: "IOT-C001-FM",
        currentReading: 45623.56,
        pressure: "0.1MPa",
        temperature: "20°C",
      },
      {
        id: "DC002",
        type: "报警器",
        model: "JT-C2商用燃气报警器",
        spec: "220V, 4-20mA",
        manufacturer: "海湾安全",
        productionDate: "2019-04-10",
        installDate: "2019-05-20",
        calibrationDate: "2025-05-20",
        nextCalibration: "2027-05-20",
        status: "正常",
        iotId: "IOT-C001-AL",
        currentReading: null,
      },
      {
        id: "DC003",
        type: "压力变送器",
        model: "EJA110A差压变送器",
        spec: "0-0.5MPa",
        manufacturer: "横河电机",
        productionDate: "2019-04-10",
        installDate: "2019-05-20",
        calibrationDate: "2024-05-20",
        nextCalibration: "2026-05-20",
        status: "正常",
        iotId: "IOT-C001-PT",
        currentReading: 0.12,
      },
    ],
    usageHistory: [
      { month: "2025-01", usage: 1580.2, cost: 6320.8 },
      { month: "2025-02", usage: 1320.5, cost: 5282.0 },
      { month: "2025-03", usage: 1180.3, cost: 4721.2 },
      { month: "2025-04", usage: 1050.8, cost: 4203.2 },
      { month: "2025-05", usage: 980.6, cost: 3922.4 },
      { month: "2025-06", usage: 920.1, cost: 3680.4 },
      { month: "2025-07", usage: 880.5, cost: 3522.0 },
      { month: "2025-08", usage: 910.2, cost: 3640.8 },
      { month: "2025-09", usage: 1020.6, cost: 4082.4 },
      { month: "2025-10", usage: 1180.3, cost: 4721.2 },
      { month: "2025-11", usage: 1380.8, cost: 5523.2 },
      { month: "2025-12", usage: 1520.6, cost: 6082.4 },
    ],
  },
  {
    id: "C002",
    name: "北京华联超市（朝阳店）",
    type: "大型企事业",
    license: "91110105MA0002CD2Y",
    contact: "张经理",
    phone: "13612345678",
    address: "北京市朝阳区朝阳路188号",
    accountDate: "2016-11-08",
    safetyLevel: 96,
    safetyGrade: "A+",
    lastInspection: "2026-01-20",
    nextInspection: "2026-07-20",
    monthlyUsage: 8562.3,
    yearlyUsage: 102747.6,
    balance: 25680.00,
    status: "正常",
    insurance: { valid: true, expiry: "2026-11-30", company: "太平洋保险" },
    devices: [
      {
        id: "DC004",
        type: "流量计",
        model: "LWQ-200涡轮流量计",
        spec: "DN200, 0-1000m³/h",
        manufacturer: "北京天信仪表",
        productionDate: "2016-10-15",
        installDate: "2016-11-08",
        calibrationDate: "2024-11-08",
        nextCalibration: "2026-11-08",
        status: "正常",
        iotId: "IOT-C002-FM",
        currentReading: 356821.45,
        pressure: "0.4MPa",
        temperature: "18°C",
      },
      {
        id: "DC005",
        type: "压力变送器",
        model: "EJA110A差压变送器",
        spec: "0-1.0MPa",
        manufacturer: "横河电机",
        productionDate: "2016-10-15",
        installDate: "2016-11-08",
        calibrationDate: "2024-11-08",
        nextCalibration: "2026-11-08",
        status: "正常",
        iotId: "IOT-C002-PT",
        currentReading: 0.38,
      },
    ],
    usageHistory: [
      { month: "2025-01", usage: 10256.8, cost: 51284.0 },
      { month: "2025-02", usage: 9856.2, cost: 49281.0 },
      { month: "2025-03", usage: 8562.5, cost: 42812.5 },
      { month: "2025-04", usage: 7856.3, cost: 39281.5 },
      { month: "2025-05", usage: 7256.8, cost: 36284.0 },
      { month: "2025-06", usage: 6856.2, cost: 34281.0 },
      { month: "2025-07", usage: 6562.5, cost: 32812.5 },
      { month: "2025-08", usage: 6856.3, cost: 34281.5 },
      { month: "2025-09", usage: 7856.8, cost: 39284.0 },
      { month: "2025-10", usage: 8856.2, cost: 44281.0 },
      { month: "2025-11", usage: 9562.5, cost: 47812.5 },
      { month: "2025-12", usage: 10256.3, cost: 51281.5 },
    ],
  },
  {
    id: "C003",
    name: "北京燃气热力工程设计院",
    type: "特殊行业",
    license: "91110108MA0003EF3Z",
    contact: "赵院长",
    phone: "13712345678",
    address: "北京市海淀区西三环北路甲2号",
    accountDate: "2012-03-15",
    safetyLevel: 99,
    safetyGrade: "A+",
    lastInspection: "2026-02-01",
    nextInspection: "2026-08-01",
    monthlyUsage: 25680.5,
    yearlyUsage: 308166.0,
    balance: 86520.00,
    status: "正常",
    insurance: { valid: true, expiry: "2027-03-31", company: "中国人保" },
    devices: [
      {
        id: "DC006",
        type: "流量计",
        model: "LWQ-500超声波流量计",
        spec: "DN500, 0-5000m³/h",
        manufacturer: "艾默生",
        productionDate: "2012-02-20",
        installDate: "2012-03-15",
        calibrationDate: "2025-03-15",
        nextCalibration: "2027-03-15",
        status: "正常",
        iotId: "IOT-C003-FM",
        currentReading: 1256823.68,
        pressure: "0.8MPa",
        temperature: "22°C",
      },
    ],
    usageHistory: [
      { month: "2025-01", usage: 32560.8, cost: 195364.8 },
      { month: "2025-02", usage: 28560.2, cost: 171361.2 },
      { month: "2025-03", usage: 25680.5, cost: 154083.0 },
      { month: "2025-04", usage: 22560.3, cost: 135361.8 },
      { month: "2025-05", usage: 20256.8, cost: 121540.8 },
      { month: "2025-06", usage: 18856.2, cost: 113137.2 },
      { month: "2025-07", usage: 17562.5, cost: 105375.0 },
      { month: "2025-08", usage: 18256.3, cost: 109537.8 },
      { month: "2025-09", usage: 22856.8, cost: 137140.8 },
      { month: "2025-10", usage: 26856.2, cost: 161137.2 },
      { month: "2025-11", usage: 30562.5, cost: 183375.0 },
      { month: "2025-12", usage: 33256.3, cost: 199537.8 },
    ],
  },
];

export const allUsers = [
  ...residentUsers.map(u => ({ ...u, category: "居民用户" })),
  ...commercialUsers.map(u => ({ ...u, category: "工商业用户" })),
];
